import { NotificationSuccessIcon } from '@tableau/icons/NotificationSuccessIcon';
import { ButtonType, ButtonWidget, TextFieldWidget, ToastType, ToastWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import TagHttpClient from '~src/httpClient/TAG/TagHttpClient';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { hoursLeftToExpire, isValidDomain } from '../helpers/CustomDomainHelper';
import { AddCustomDomainTagRequest } from '../serverAPI/requests/AddOrUpdateCustomDomainTagRequest';
import { AddOrUpdateCustomDomainSettingRequest, CustomDomainSettingResponse, Status } from '../serverAPI/types/CustomDomainTypes';
import { customDomainButtonStyle, customDomainContentStyle, customDomainHeaderContainer, customDomainSubHeaderStyle, customDomainWideField, intermediateDomainTextStyle, intermediateDomainwarningStyle, lineIconBaseStyle, lineIconStyle, progressIconContent, stepIconStyle, successIconStyle } from '../styles/CustomDomainStyles';

export interface AddCustomDomainViewState {
    isUploading: boolean;
    textValue: string;
  }

export interface AddCustomDomainViewProps {
    customDomainSetting: CustomDomainSettingResponse;
    triggerFetchCustomDomain(): void;
  }

export class AddCustomDomainView extends React.PureComponent<AddCustomDomainViewProps, AddCustomDomainViewState> {
  public constructor(props: AddCustomDomainViewProps) {
    super(props);
    this.state = {
      isUploading: false,
      textValue: ''
    };
  }

  private addCustomDomainSetting = (): void => {
    const customDomainSetting: AddOrUpdateCustomDomainSettingRequest = {
      site_luid: getSessionManagementServiceInstance().sessionSiteLuid(),
      custom_domain: this.state.textValue ? this.state.textValue.trim() : this.state.textValue,
      status: Status.requested,
      tls_certificate: null,
      tls_certificate_private_key: null
    };

    this.setState({isUploading: true});
      TagHttpClient.sendTagRequest(new AddCustomDomainTagRequest(customDomainSetting)).then((res: CustomDomainSettingResponse)  => {
        if(res.errors && res.errors.length > 0) {
          ToastWidget.show({message: Messages.CustomDomainSetting_addFailed(), testId: 'toast-add-custom-domain-failed', toastType: ToastType.Error});
        }
       this.props.triggerFetchCustomDomain();
     }).catch(err => {
       ToastWidget.show({message: Messages.CustomDomainSetting_addFailed(), testId: 'toast-add-custom-domain-failed', toastType: ToastType.Error});
     }).finally(() => {
      this.setState({isUploading: false});
     });
  };

  private renderIntermediateDomainText() {
    if(!this.props.customDomainSetting?.intermediate_domain) {
      return null;
    }
    let textStyle = intermediateDomainTextStyle;
    let hoursLeft = hoursLeftToExpire(this.props.customDomainSetting?.request_initiation_date);
    if(hoursLeft <= 0) {
      textStyle = intermediateDomainwarningStyle;
    }

    return <div className={textStyle}>
              {Messages.CustomDomainSetting_intermediateDomain({INTERMEDIATE_DOMAIN: this.props.customDomainSetting.intermediate_domain})}{hoursLeft<=0 ? ' '+ Messages.expired() : null}
            </div>;
  }

  private renderIcon() {
    if(this.props.customDomainSetting?.intermediate_domain) {
      return <NotificationSuccessIcon size={24} alt={Messages.backgroundJobStatusCompleted()} className={successIconStyle}/>;
    }
    return <div className={stepIconStyle}><div className = {progressIconContent}>1</div></div>;
  }

  private renderAddCustomDomainSettingView() {
    return <>
          <div className={customDomainContentStyle}>
            <TextFieldWidget testId={'textfield-custom-domain'}
                            className={customDomainWideField}
                            placeholder={this.getPlaceHolderText()}
                            onChange={e => this.setState({textValue : e.target.value})}
                            value={this.state.textValue}
                            required={true}
                            valid={isValidDomain(this.state.textValue)}
                            label={Messages.CustomDomainSetting_addLabelDescription()}
                            disabled={this.props.customDomainSetting?.intermediate_domain ? true : false}
            />
            <div className={customDomainButtonStyle}>
              <ButtonWidget buttonType={ButtonType.Primary} showSpinner={this.state.isUploading} onClick={this.addCustomDomainSetting} testId='button-custom-domain-save' disabled={this.isSaveDisabled()}>
                {Messages.save()}
              </ButtonWidget>
            </div>
          </div>
    </>;
  }

  private isSaveDisabled() {
    if(this.props.customDomainSetting?.intermediate_domain)
      return true;
    return !isValidDomain(this.state.textValue);
  }

  private getPlaceHolderText(){
    return this.props.customDomainSetting?.intermediate_domain ? this.props.customDomainSetting?.custom_domain : 'analytics.example.com';
  }

  private getStepIconStyle() {
    return this.props.customDomainSetting?.intermediate_domain ? lineIconBaseStyle : lineIconStyle;
  }

  public render() {
    return (
    <>
      <div className={customDomainHeaderContainer}>
        {this.renderIcon()}
        <strong style={customDomainSubHeaderStyle}>{Messages.CustomDomainSetting_addLabel()}</strong>
      </div>
      <div style={this.getStepIconStyle()}>
        {this.renderAddCustomDomainSettingView()}
        <div className={customDomainContentStyle}>
          {this.renderIntermediateDomainText()}
        </div>
      </div>
    </>
    );
  }

}